import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import LandingPage from "./components/UserAccount/LandingPage";
import ForgotPassword from "./components/UserAccount/ForgotPassword";
import {
  Dashboard,
  DismissalTimes,
  PriorAndFutureDelegations,
  Nokids,
} from "./components/Dashboard";
import Error from "./Error";
import {
  RegisterName,
  RegisterEmail,
  ConfirmEmail,
  RegisterPhone,
  ConfirmPhone,
  RegisterPassword,
  RegisterSuccess,
  ChooseRole,
  RegisterSupport,
} from "./components/UserAccount/Registration";
import { NotificationsList, ChangePassword, Setting } from "./components/Settings";
import { ChildManagement } from "./components/ChildManagement";
import { Checkin } from "./components/Checkin";
import { BootstrapModal, LoadAds } from "./components/CommonComponents";
import { PrivateRoute,TermsConditions } from "./components/CommonComponents";
import { Notifications } from 'react-push-notification';
import ScanBarCode from "./components/Scanner/ScanBarCode"
class Routes extends React.Component {
  render() {
    return (
      <Router>
        <Notifications />
        <Switch>
          <Route exact path="/" component={LandingPage} />
          <PrivateRoute path="/dashboard" component={Dashboard} />
          <Route path="/registerName" component={RegisterName} />
          <Route path="/registerEmail" component={RegisterEmail} />
          <Route path="/confirmEmail" component={ConfirmEmail} />
          <Route path="/registerPhone" component={RegisterPhone} />
          <Route path="/confirmPhone" component={ConfirmPhone} />
          <Route path="/registerPassword" component={RegisterPassword} />
          <Route path="/registerSuccess" component={RegisterSuccess} />
          <Route path="/chooseRole" component={ChooseRole} />
          <Route path="/support" component={RegisterSupport} />
          <PrivateRoute path="/notifications" component={NotificationsList} />
          <PrivateRoute path="/changePassword" component={ChangePassword} />
          <PrivateRoute path="/setting" component={Setting} />
          <PrivateRoute path="/childManagement" component={ChildManagement} />
		  <PrivateRoute path="/termsConditions" component={TermsConditions} />
          <PrivateRoute path="/dismissalTimes" component={DismissalTimes} />
          <Route
            path="/priorAndFutureDelegations"
            component={PriorAndFutureDelegations}
          />
          <Route path="/nokids" component={Nokids} />
          <Route path="/forgotPassword" component={ForgotPassword} />
          <PrivateRoute path="/checkin" component={Checkin} />
          {/* <Route path="/SelectContact" component={SelectContact} /> */}
          {/* <Route path="/:addContact" component={SelectContact} /> */}
          {/* <Route path="/BootstrapModal" component={BootstrapModal}/> */}
          <Route component={Error} />
        </Switch>
        <BootstrapModal myLevel={0} />
        <BootstrapModal myLevel={1} />
        <BootstrapModal myLevel={2} />
        <BootstrapModal myLevel={3} />
        <PrivateRoute component={LoadAds} />
        <PrivateRoute path="/ScanBarCode" component={ScanBarCode}/>
      </Router>
    );
  }
}
export default Routes;
